import { useState } from "react";

import { useClientsQuery } from "Clients/Api/Queries/useClientsQuery";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { BlAutocomplete } from "Shared/Inputs/BlAutocomplete";
import type { BlOption } from "Shared/Inputs/BlOption";

interface ClientFilterSelectProps {
  value: BlOption | string | null;
  onChange: (value: BlOption | null) => void;
}

export const ClientFilterSelect = ({
  value,
  onChange,
}: ClientFilterSelectProps): React.ReactNode => {
  const { t } = useResource();
  const [searchQuery, setSearchQuery] = useState("");

  const { data, isLoading } = useClientsQuery({
    searchQuery: searchQuery || null,
    offset: 0,
    limit: 1000,
  });

  const options: BlOption[] = (data?.items ?? []).map((client) => ({
    value: client.clientID,
    label: client.companyName,
  }));

  return (
    <BlAutocomplete
      inputName="client-filter"
      options={options}
      value={
        typeof value === "string"
          ? options.find((option) => option.value === value)
          : value
      }
      onOptionSelected={onChange}
      onSearch={setSearchQuery}
      placeholder={t(Resources.Dashboard.Client)}
      isLoading={isLoading}
    />
  );
};
